//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head () {
    return {
      title: this.getTitle('Contact Us'),
      meta: [
        ...this.getDescription('Get in touch with the SunGod Support team with any unanswered questions.'),
        { hid: 'og:title', property: 'og:title', content: this.getTitle('Contact Us') }
      ]
    }
  }
}
